import React, { useState, useContext } from 'react';
import { UserContext } from '../../../lib/usercontext';
import { useLocation, useNavigate } from 'react-router-dom';
import GeneralButton from '../button_general';
import ClientModal from '../modals/client_modal';

function CustomerFilterComponent({ onFilterChange, selectedClient, selectedStatus, selectedDeliveryDay, selectedProviderRoute  }) {
    const { user } = useContext(UserContext);
    const role = user.userGroups ? user.userGroups[0] : 'Customer';
    const isAdmin = role === 'Admin'; 

    const navigate = useNavigate();
    const location = useLocation();

    const [isClientModalOpen, setIsClientModalOpen] = useState(false);
    const [client, setClient] = useState(selectedClient || '');
    const [status, setStatus] = useState(selectedStatus || '');
    const [deliveryDay, setDeliveryDay] = useState(selectedDeliveryDay || '');
    const [providerRoute, setProviderRoute] = useState(selectedProviderRoute || '');
    const [name, setName] = useState('');
    const [referenceId, setReferenceId] = useState('');

    const statusOptions = [
        { label: 'All', value: '' },
        { label: 'Active', value: 'active' },
        { label: 'On Hold', value: 'on_hold' },
        { label: 'Inactive', value: 'inactive' },
        { label: 'Disenrolled', value: 'disenrolled' },
        { label: 'Deceased', value: 'deceased' },
    ];

    const deliveryDaysOptions = [
        { label: 'Sunday', value: '0' },
        { label: 'Monday', value: '1' },
        { label: 'Tuesday', value: '2' },
        { label: 'Wednesday', value: '3' },
        { label: 'Thursday', value: '4' },
        { label: 'Friday', value: '5' },
        { label: 'Saturday', value: '6' },
    ];

    const handleFilterApply = (overrideClient) => {
        const effectiveClient = overrideClient !== undefined ? overrideClient : client;
        const params = new URLSearchParams(location.search);
    
        if (effectiveClient && effectiveClient.client_id) {
            params.set('client', effectiveClient.client_id);
        } else {
            params.delete('client');
        }
    
        if (status) {
            params.set('status', status);
        } else {
            params.delete('status');
        }
    
        if (deliveryDay) {
            params.set('delivery_day', deliveryDay);
        } else {
            params.delete('delivery_day');
        }
    
        if (name) {
            params.set('search', name);
        } else {
            params.delete('search');
        }

        if (providerRoute) {
            params.set('provider_route', providerRoute);
        } else {
            params.delete('provider_route');
        }
    
        if (referenceId) {
            params.set('reference_id', referenceId);
        } else {
            params.delete('reference_id');
        }
    
        navigate({ search: params.toString() });
        onFilterChange(effectiveClient, status, deliveryDay, providerRoute);
    };

    const handleFilterClear = () => {
        setClient('');
        setStatus('');
        setDeliveryDay('');
        setName('');
        setReferenceId('');
        setProviderRoute('');

        const params = new URLSearchParams(location.search);
        params.delete('client');
        params.delete('status');
        params.delete('delivery_day');
        params.delete('search');
        params.delete('reference_id');
        params.delete('provider_route');

        navigate({ search: '' });
        onFilterChange('', '', '', '');
    };

    return (
        <div className="filter-component flex flex-wrap items-end space-x-4 ml-2 mb-0">            
            <div className="flex flex-col mb-4">
                <label htmlFor="reference_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Reference ID</label>
                <input
                    id="reference_id"
                    type="text"
                    placeholder="Search by reference ID"
                    value={referenceId}
                    onChange={(e) => setReferenceId(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
            </div>
            <div className="flex flex-col mb-4">
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
                <input
                    id="name"
                    type="text"
                    placeholder="Search by name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
            </div>
            <div className="flex flex-col mb-4">
                <label htmlFor="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Status</label>
                <select
                    id="status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                    {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>
            <div className="flex flex-col mb-4">
                <label htmlFor="delivery_day" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Delivery Day</label>
                <select
                    id="delivery_day"
                    name="delivery_day"
                    value={deliveryDay}
                    onChange={(e) => setDeliveryDay(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full min-w-[180px] p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                    <option value="">Select Delivery Day</option>
                    {deliveryDaysOptions.map((day) => (
                        <option key={day.value} value={day.value}>{day.label}</option>
                    ))}
                </select>
            </div>
            {isAdmin ? (<div className="flex flex-col">
                <ClientModal
                    isOpen={isClientModalOpen}
                    setIsOpen={setIsClientModalOpen}
                    selectClient={(client) => {
                        setClient(client);
                        handleFilterApply(client);
                    }}
                    value={client}
                    isSelectable={true}
                    useButton={false}
                />
            </div>) : null}
            <div className="flex flex-col mb-4">
                <label htmlFor="provider_route" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Provider Route</label>
                <input
                    id="provider_route"
                    type="text"
                    placeholder="Search by Provider Route"
                    value={providerRoute}
                    onChange={(e) => setProviderRoute(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
            </div>
            <div className="flex flex-col mb-4">
                <GeneralButton type="button" buttonType="primary" onClick={() => handleFilterApply()}>
                    Apply Filters
                </GeneralButton>
            </div>
            <div className="flex flex-col mb-4">
                <GeneralButton type="button" buttonType="secondary" onClick={() => handleFilterClear()}>
                    Clear Filters
                </GeneralButton>
            </div>
        </div>
    );
}

export default CustomerFilterComponent;
